export default __webpack_public_path__ + "static/media/Partner-Ohcat.1b15c52f.png";